import { render, staticRenderFns } from "./select-location-type-app.vue?vue&type=template&id=3f82ea32&"
import script from "./select-location-type-app.vue?vue&type=script&lang=js&"
export * from "./select-location-type-app.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports